export default "__VITE_ASSET__66b24a42__"